module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; 
var groupTitles = function (groupLevel) {
    var group = groups.find(function (g) {
            return g.value === groupBy;
        }) || {};

    return group.groupTitle;
};

/*var recurseRowCounter = function (rows, deep) {
    deep--;
    if (deep) {
        return _.reduce(rows, function (reducer, row) {
            reducer += recurseRowCounter(row);
            return reducer;
        }, 0);
    } else {
        return rows.length;
    }
}*/

var toHectare = function (value) {
    if (value == null || value === '') {
        return '';
    }
    return _.round(value / 10000, 0);
};

var numFormat = function (num) {
    num = num? num + '' : '';
    return num.replace('.', ',');
}
var format = function (type, value) {
    switch (type) {
        case 'fields_num':
            return numFormat(value);
            break;
        case 'spatial_area':
            return toHectare(value);
            break;
    }
}

    ; __append("\n\n<div class=\"wh100\">\n\n    ")
    ;  var titleClasses = _.reduce(groupTitles(), function (reducer) {
        reducer.push('.width-regulator td:nth-child(' + (reducer.length+1) + ')');
        return reducer;
    }, []);
    ; __append("\n\n    <style>\n        ")
    ; __append(escapeFn( titleClasses ))
    ; __append(" {\n            width : 18%;\n        }\n        .width-regulator td:nth-child(")
    ; __append(escapeFn( (groupTitles().length + 1) ))
    ; __append(") {\n            width : 9%;\n        }\n        .width-regulator thead td,\n        .width-regulator td:nth-child(1){\n            word-wrap:break-word;\n        }\n    </style>\n\n\n    ")
    ;  var deep = groupTitles().length;

    var recurseRowWrite = function(fixedCells, data, geep) {
        if (data.rows) {
            geep--;
            _.forEach(data.rows, function (data, title) {
                fixedCells.push({
                    'title': title,
                    'rowspan': data.rowsCount
                });
                recurseRowWrite(fixedCells, data, geep);
            });
            geep++;
            if (data.rowsCount > 1) { 
    ; __append("\n            <tr>\n                <th colspan=\"")
    ; __append(escapeFn( geep ))
    ; __append("\">Итого</th>\n                ")
    ;  _.forEach(data.total, function (cell, field) { 
    ; __append("\n                    <th>")
    ; __append(escapeFn( format(field, cell) ))
    ; __append("</th>\n                ")
    ;  }) 
    ; __append("\n            </tr>\n            ")
    ;  }
        } else {
    ; __append("\n            <tr>\n                ")
    ;  while (fixedCells.length>0) {
                    var cell = fixedCells.shift();
    ; __append("\n                <td rowspan=\"")
    ; __append(escapeFn( cell.rowspan))
    ; __append("\">")
    ; __append(escapeFn( cell.title ))
    ; __append("</td>\n                ")
    ;  } 
    ; __append("\n                ")
    ;  _.forEach(data, function (row) {
                    _.forEach(row, function (cell, field) { 
    ; __append("\n                        <td>")
    ; __append(escapeFn( format(field, cell) ))
    ; __append("</td>\n                    ")
    ;  })
                }) 
    ; __append("\n            </tr>\n        ")
    ;  }
    }
            
    ; __append("\n\n\n\n\n    <table class=\"w100 gl-report__table width-regulator\">\n        <thead>\n        <tr>\n            ")
    ;  groupTitles().forEach(function (title) { 
    ; __append("\n                <td>")
    ; __append(escapeFn( title ))
    ; __append("</td>\n            ")
    ;  }); 
    ; __append("\n            <td rowspan=\"2\">Количество</td>\n            <td colspan=\"2\">Площадь, га</td>\n        </tr>\n        </thead>\n    </table>\n\n    <div class=\"wh100\">\n        <div class=\"cell__abs_container\">\n            <div class=\"cell__abs overflow-y__auto\">\n                <table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n                    <tbody>\n                        ")
    ;  recurseRowWrite([], data, groupTitles().length) 
    ; __append("\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n\n\n</div>\n")
  }
  return __output.join("");

}